<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="false"
      title="Naar Opleveren"
      @next-step="$router.push({ name: 'copyOrderDeliver' })"
    ></next-prev-menu>

    <pick-up
      :orderDetails="orderDetails"
      :shop="shop"
      :dates="dates"
      @updateOrder="updateOrder"
    ></pick-up>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useCopyOrderStore } from '@/features/copyOrder/CopyOrder.store'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import OrderMixin from '@/mixins/OrderMixin'
import PickUp from '@/components/PickUp.vue'

export default {
  data() {
    return {}
  },
  mixins: [OrderMixin],
  components: {
    NextPrevMenu,
    PickUp
  },
  methods: {
    updateOrder(val) {
      this.copyOrderStore.updateOrderDetails(val[0], val[1])
    }
  },
  computed: {
    ...mapStores(useCopyOrderStore),
    orderDetails() {
      return this.copyOrderStore.orderDetails
    },
    shop() {
      return this.copyOrderStore.shop
    },
    dates() {
      return this.copyOrderStore.pickUpDates
    }
  },
  created() {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.card {
  //height: 590px;
}
</style>
